import { z } from 'zod';

export const keycloakTokenResponseSchema = z.object({
  access_token: z.string(),
  expires_in: z.number(),
  refresh_token: z.string(),
  refresh_expires_in: z.number(),
});
export type KeycloakTokenResponseSchema = z.infer<
  typeof keycloakTokenResponseSchema
>;
